module.exports = __webpack_public_path__ + "static/media/pic2.55592452.jpg";